import React from "react";
import { GoogleLogo } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleSignInButton({ label = "Continue with Google", testId = "google-signin-button" }) {
  const onClick = () => {
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className="w-full h-11 rounded-full border border-border bg-card hover:bg-secondary text-sm font-medium inline-flex items-center justify-center gap-2.5"
      style={{ transition: "background-color 0.2s ease, border-color 0.2s ease" }}
    >
      <GoogleLogo size={18} weight="bold" />
      {label}
    </button>
  );
}
